import { render, staticRenderFns } from "./TravTabs.vue?vue&type=template&id=017d8ee2&scoped=true&"
import script from "./TravTabs.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TravTabs.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./TravTabs.vue?vue&type=style&index=0&id=017d8ee2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017d8ee2",
  null
  
)

export default component.exports